import React from 'react'

import AppPage from '../../templates/app-page'
import styled from 'styled-components'

const Page404: React.FunctionComponent = () => {
    return <AppPage name="404">
        <Container>
            <NotFound>
                404
            </NotFound>
            <Text>Page you're looking for doesn't exist</Text>
        </Container>
    </AppPage>
}

const Container = styled.div`
    display: grid;
    align-items: center;
    justify-items: center;

    grid-gap: 30px;
    padding: 30px;

    width: 100%;
    height: fit-content;

    color: ${p => p.theme.colors.accent};
`

const NotFound = styled.div`
    font-size: 300px;
    font-weight: bold;
`

const Text = styled.div`
    font-size: 24px;
`

export default Page404